<template>
  <div id="app" class="muharram-page">
    <v-app>

      <!-- ═══════════ VIDEO BACKGROUND ═══════════ -->
      <div class="bg-video-wrap">
        <video autoplay loop muted id="video-background" ref="videoss">
          <source :src="'/assets/img/moharam/test1.mp4'" type="video/mp4">
        </video>
        <div class="bg-overlay"></div>
      </div>

      <!-- ═══════════ HEADER BAR ═══════════ -->
      <div class="top-header">
        <router-link :to="'/?lang='+lang" class="header-logo">
          <img :src="'https://alkafeel.net/'+lang_src+'/'+logo" alt="Logo" class="header-logo-img">
        </router-link>

        <nav class="header-nav d-none d-md-flex">
          <a class="nav-link" @click.prevent="scrollToSection('enabaa')">
            <svg viewBox="0 0 24 24" style="height:20px;fill:currentColor"><use xlink:href="/assets/img/moharam/enabaa2.svg#view"></use></svg>
            <span>{{$t('index_zyara')}}</span>
          </a>
          <a class="nav-link" @click.prevent="scrollToSection('live')">
            <svg viewBox="3 2 23 24" style="height:20px;fill:currentColor"><use xlink:href="/assets/img/moharam/live2.svg#view"></use></svg>
            <span>{{$t('index_live')}}</span>
          </a>
          <a class="nav-link" @click.prevent="scrollToSection('ashab')">
            <img :src="'/assets/img/moharam/ashab.svg'" style="height:22px">
            <span>{{$t('CompanionsـHussein')}}</span>
          </a>
          <a class="nav-link" @click.prevent="scrollToSection('khdham')">
            <img :src="'/assets/img/moharam/muslim.png'" style="height:22px">
            <span>{{$t('Servants_Hussein')}}</span>
          </a>
          <a class="nav-link" @click.prevent="scrollToSection('visitor')">
            <img :src="'/assets/img/moharam/map-pin.svg'" style="height:20px">
            <span>{{$t('visitor_guide')}}</span>
          </a>
        </nav>

        <div class="header-actions">
          <button class="h-action-btn d-flex d-md-none" @click="mobileMenu = !mobileMenu">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
              <line v-if="!mobileMenu" x1="3" y1="6" x2="21" y2="6"></line>
              <line v-if="!mobileMenu" x1="3" y1="12" x2="21" y2="12"></line>
              <line v-if="!mobileMenu" x1="3" y1="18" x2="21" y2="18"></line>
              <line v-if="mobileMenu" x1="6" y1="6" x2="18" y2="18"></line>
              <line v-if="mobileMenu" x1="6" y1="18" x2="18" y2="6"></line>
            </svg>
          </button>
          <button class="h-action-btn" @click="toggleSound">
            <img :src="isMuted ? '/assets/img/moharam/volume-x.svg' : '/assets/img/moharam/volume-2.svg'" style="height:20px">
          </button>
          <button class="h-action-btn" @click="dialog = true">
            <svg viewBox="0 0 25 30" style="height:20px;fill:#fff"><use xlink:href="/assets/img/services/lang.svg#view"></use></svg>
          </button>
        </div>
      </div>

      <!-- ═══════════ MOBILE NAV MENU ═══════════ -->
      <div class="mobile-nav" v-if="mobileMenu">
        <a class="mobile-nav-link" @click.prevent="scrollToSection('enabaa'); mobileMenu = false">
          <svg viewBox="0 0 24 24" style="height:20px;fill:#fff"><use xlink:href="/assets/img/moharam/enabaa2.svg#view"></use></svg>
          <span>{{$t('index_zyara')}}</span>
        </a>
        <a class="mobile-nav-link" @click.prevent="scrollToSection('live'); mobileMenu = false">
          <svg viewBox="3 2 23 24" style="height:20px;fill:#fff"><use xlink:href="/assets/img/moharam/live2.svg#view"></use></svg>
          <span>{{$t('index_live')}}</span>
        </a>
        <a class="mobile-nav-link" @click.prevent="scrollToSection('ashab'); mobileMenu = false">
          <img :src="'/assets/img/moharam/ashab.svg'" style="height:22px">
          <span>{{$t('CompanionsـHussein')}}</span>
        </a>
        <a class="mobile-nav-link" @click.prevent="scrollToSection('khdham'); mobileMenu = false">
          <img :src="'/assets/img/moharam/muslim.png'" style="height:22px">
          <span>{{$t('Servants_Hussein')}}</span>
        </a>
        <a class="mobile-nav-link" @click.prevent="scrollToSection('visitor'); mobileMenu = false">
          <img :src="'/assets/img/moharam/map-pin.svg'" style="height:20px">
          <span>{{$t('visitor_guide')}}</span>
        </a>
      </div>

      <!-- ═══════════ LANGUAGE DIALOG ═══════════ -->
      <v-dialog v-model="dialog" max-width="420" overlay-opacity="0.85">
        <v-card class="lang-dialog-card">
          <v-card-title class="lang-dialog-title justify-center">
            <svg viewBox="0 0 25 30" style="height:24px;fill:#fff;margin:0 8px"><use xlink:href="/assets/img/services/lang.svg#view"></use></svg>
            <span>{{$t('lang') || 'اللغة'}}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-list class="lang-list">
              <v-list-item v-for="(language, index) in languages" :key="index" :href="'?lang='+language.code" class="lang-item">
                <v-list-item-content>
                  <v-list-item-title class="lang-item-title">{{ language.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center pa-3">
            <v-btn class="lang-close-btn" text @click="dialog = false">{{$t("close")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ═══════════ MAIN CONTENT ═══════════ -->
      <div class="main-content">

        <!-- SECTION: ZYARA -->
        <section class="sec sec-zyara" id="enabaa">
          <div class="sec-wrap">
            <div class="sec-head">
              <div class="sec-ornament"><span class="orn-line"></span><img src="/assets/img/moharam/z-mohammed.svg" class="orn-icon"><span class="orn-line"></span></div>
              <a :href="'https://alkafeel.net/zyara?lang=' + $i18n.locale" class="sec-title-link"><h2 class="sec-title">{{$t('index_zyara')}}</h2></a>
            </div>
            <div class="zyara-content">
              <p class="zyara-sub" v-if="zyaraData.title">{{ zyaraData.title }}</p>
              <v-form ref="form" v-model="valid" class="zyara-form">
                <div class="zyara-row">
                  <v-text-field v-model="zeara_i.name" solo flat dark color="#c0392b" :placeholder="$t('zyara_ab')" hide-details="auto" :rules="[rules.required]" class="zyara-field"></v-text-field>
                  <v-text-field v-model="zeara_i.email" solo flat dark color="#c0392b" :placeholder="$t('msg_email_optional')" hide-details="auto" :rules="[rules.email]" class="zyara-field"></v-text-field>
                  <v-btn class="zyara-btn" :loading="loading" @click="zyara_send()">
                    <span>{{ $t('action_send') }}</span>
                  </v-btn>
                </div>
              </v-form>
            </div>
          </div>
        </section>

        <!-- SECTION: LIVE -->
        <section class="sec sec-live" id="live">
          <div class="sec-wrap">
            <div class="sec-head">
              <div class="sec-ornament"><span class="orn-line"></span><img src="/assets/img/moharam/z-mohammed.svg" class="orn-icon"><span class="orn-line"></span></div>
              <router-link :to="'/stream?lang='+$i18n.locale" class="sec-title-link"><h2 class="sec-title">{{$t('index_live')}}</h2></router-link>
            </div>
            <div class="live-grid">
              <div class="live-player">
                <div class="player-frame">
                  <v-skeleton-loader v-if="playerLoading" style="height:100%;border-radius:12px" v-bind="attrs" type="image"></v-skeleton-loader>
                  <video v-show="!playerLoading" ref="videoPlayer" class="video-js vjs-theme-dt vjs-costum"></video>
                </div>
              </div>
              <div class="live-channels">
                <div class="channels-list">
                  <div v-for="source in live" :key="'l-'+source.id" class="ch-card" :class="{'ch-active': activeId === source.id}" @click="playSrc(source.src, source.pic, source.title, source.id)">
                    <div class="ch-icon"><svg viewBox="0 0 35 25" style="height:16px;fill:currentColor"><use xlink:href="/assets/img/live/cam.svg#view"></use></svg></div>
                    <span class="ch-name">{{source.title}}</span>
                  </div>
                  <div v-for="source in atabat" :key="'a-'+source.id" class="ch-card" :class="{'ch-active': activeId === source.id}" @click="playSrc(source.src, source.pic, source.title, source.id, source.stream_type, true)">
                    <div class="ch-icon"><svg viewBox="0 0 35 25" style="height:16px;fill:currentColor"><use xlink:href="/assets/img/live/cam.svg#view"></use></svg></div>
                    <span class="ch-name">{{source.title}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- SECTION: EVENTS -->
        <section class="sec sec-events" id="events" v-if="lang == 'ar' && events != null">
          <div class="sec-wrap">
            <div class="sec-head">
              <div class="sec-ornament"><span class="orn-line"></span><img src="/assets/img/moharam/z-mohammed.svg" class="orn-icon"><span class="orn-line"></span></div>
              <h2 class="sec-title">{{$t('today_events')}}</h2>
            </div>
            <div class="events-card"><p class="events-text">{{ events }}</p></div>
          </div>
        </section>

        <!-- SECTION: COMPANIONS -->
        <section class="sec sec-ashab" id="ashab">
          <div class="sec-wrap">
            <div class="sec-head">
              <div class="sec-ornament"><span class="orn-line"></span><img src="/assets/img/moharam/z-mohammed.svg" class="orn-icon"><span class="orn-line"></span></div>
              <router-link class="sec-title-link" :to="'/muharram?lang='+$i18n.locale"><h2 class="sec-title">{{$t('CompanionsـHussein')}}</h2></router-link>
            </div>
            <div class="ashab-grid">
              <div class="ashab-info"><h3 class="ashab-name" id="title">{{ currentTitle }}</h3><p class="ashab-desc" id="description">{{ currentDescription }}</p></div>
              <div class="ashab-cards-area">
                <div class="ashab-cards-wrap">
                  <div v-for="(card, index) in cards" :key="index" class="ashab-card" :class="{'ashab-card-main': index === 1}" :style="{ transform: 'rotate(' + (index === 0 ? -8 : (index === 1 ? 6 : -4)) + 'deg)', zIndex: index === 1 ? 3 : (index === 0 ? 2 : 1) }">
                    <img :src="card.image.replace('/thumb/', '/thumb2/')" :alt="card.title">
                    <div class="ashab-card-overlay" v-if="index === 1"><span>{{ card.title }}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ashab-nav">
              <button class="arr-btn" @click="showPrev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg></button>
              <div class="ashab-counter"><span class="ctr-cur">{{ (currentCard % cardData.length) + 1 }}</span><span class="ctr-sep">/</span><span class="ctr-total">{{ cardData.length }}</span></div>
              <button class="arr-btn" @click="showNext"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg></button>
            </div>
          </div>
        </section>

        <!-- SECTION: SERVANTS -->
        <section class="sec sec-khdham" id="khdham">
          <div class="sec-wrap">
            <div class="sec-head">
              <div class="sec-ornament"><span class="orn-line"></span><img src="/assets/img/moharam/z-mohammed.svg" class="orn-icon"><span class="orn-line"></span></div>
              <a :href="'https://alkafeel.net/muharram/?lang=ar'" class="sec-title-link"><h2 class="sec-title">{{$t('Servants_Hussein')}}</h2></a>
            </div>
            <span class="watermark-text">يا حسين</span>
            <template v-if="khudam.length">
              <VueSlickCarousel v-bind="settings">
                <div v-for="(data, i) in khudam" :key="'k-'+i">
                  <div class="kh-card" :class="{'kh-offset': (i % 2)}">
                    <div class="kh-inner" @click="openModal('modal', data)">
                      <img :src="data.image" :alt="data.title" class="kh-img">
                      <div class="kh-info"><h3 class="kh-name">{{ data.title }}</h3></div>
                      <div class="kh-shine"></div>
                    </div>
                  </div>
                </div>
              </VueSlickCarousel>
            </template>
            <div class="ashura-btn-wrap">
              <button class="ashura-btn" @click="open_ashs()">
                <svg viewBox="0 0 24 24" style="height:28px;fill:#fff;margin:0 10px"><use xlink:href="/assets/img/moharam/enabaa2.svg#view"></use></svg>
                <span>{{$t("Dedicating_reward_reciting_ Ashura_visit_the souls_serving_Hussein")}}</span>
              </button>
            </div>

            <!-- Ashura Visit Dialog -->
            <v-dialog v-model="open_ash" max-width="900">
              <v-card class="dlg-card">
                <v-btn class="dlg-close" @click="open_ash = false" icon dark small>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 5L5 15M5 5l10 10" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>
                </v-btn>
                <div class="dlg-body">
                  <h3 class="dlg-title">{{$t("Dedicating_reward_reciting_ Ashura_visit_the souls_serving_Hussein")}}</h3>
                  <div class="dlg-divider"></div>
                  <p class="dlg-label">نص الزيارة</p>
                  <div class="dlg-zyara-text">{{ shour }}</div>
                </div>
                <v-card-actions class="pa-4"><v-spacer></v-spacer><v-btn class="dlg-close-btn" text @click="open_ash = false">{{$t("close")}}</v-btn></v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Servant Detail Dialog -->
            <v-dialog v-model="amd_dialog" max-width="900">
              <v-card class="dlg-card">
                <v-btn class="dlg-close" @click="amd_dialog = false" icon dark small>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 5L5 15M5 5l10 10" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>
                </v-btn>
                <div class="dlg-body" v-if="Amd">
                  <div class="dlg-profile"><img :src="Amd.image" class="dlg-avatar"><h3 class="dlg-profile-name">{{ Amd.title }}</h3></div>
                  <div class="dlg-divider"></div>
                  <div class="dlg-text" v-html="bbcode(Amd.description)"></div>
                </div>
                <v-card-actions class="pa-4"><v-spacer></v-spacer><v-btn class="dlg-close-btn" text @click="amd_dialog = false">{{$t("close")}}</v-btn></v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </section>

        <!-- SECTION: VISITOR GUIDE -->
        <section class="sec sec-visitor" id="visitor">
          <div class="sec-wrap">
            <div class="sec-head">
              <div class="sec-ornament"><span class="orn-line"></span><img src="/assets/img/moharam/z-mohammed.svg" class="orn-icon"><span class="orn-line"></span></div>
              <h2 class="sec-title">{{$t('visitor_guide')}}</h2>
            </div>
            <div class="visitor-card">
              <div class="visitor-search">
                <v-text-field v-model="search" @keyup.enter="searchs" solo flat dark color="#c0392b" :label="$t('visitor_guide_search')" hide-details="auto" outlined class="visitor-input">
                  <template v-slot:append>
                    <v-btn class="visitor-search-btn" @click="searchs();page=1"><svg viewBox="0 0 26 25" style="height:16px;fill:#fff;margin:0 4px"><use xlink:href="/assets/img/services/search.svg#view"></use></svg><span>{{$t('search')}}</span></v-btn>
                  </template>
                </v-text-field>
              </div>
              <div class="visitor-tabs">
                <button v-for="(PlacesCat, idx) in PlacesCats" :key="'cat-'+idx" class="vtab" :class="{'vtab-active': tabs === idx}" @click="tabs = idx; getPlace(PlacesCat.category_id, page=1, is_search=false)">{{ PlacesCat.category_name }}</button>
              </div>
              <div class="visitor-body">
                <h4 class="visitor-body-title" v-if="!is_search && PlacesCats[tabs]">{{ PlacesCats[tabs].category_name }}</h4>
                <h4 class="visitor-body-title" v-else>نتائج البحث</h4>
                <div class="places-grid">
                  <div v-for="(Guid, gi) in Guids" :key="'g-'+gi" class="place-card" @click="show(Guid.place_name, Guid.place_address, '', Guid.place_lat, Guid.place_lng)">
                    <div class="place-icon"><img :src="'/assets/img/moharam/pin.svg'" style="height:40px"></div>
                    <div class="place-info">
                      <h5 class="place-name" v-if="Guid.place_name">{{ Guid.place_name }}</h5>
                      <h5 class="place-name" v-else>{{ Guid.title }}</h5>
                      <span class="place-addr" v-if="Guid.place_address">{{ Guid.place_address }}</span>
                      <span class="place-addr" v-else>{{ Guid.caption }}</span>
                    </div>
                    <div class="place-arrow"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg></div>
                  </div>
                </div>
                <div class="visitor-pag" v-if="pageCount > 1"><v-pagination v-model="page" :length="pageCount" @input="next" color="#c0392b" dark></v-pagination></div>
              </div>
            </div>
          </div>
        </section>

      </div>

      <!-- ═══════════ FOOTER ═══════════ -->
      <div class="page-footer">
        <router-link :to="'/?lang='+lang" class="footer-logo"><img :src="'https://alkafeel.net/'+lang_src+'/'+logo" alt="Logo" class="footer-logo-img"></router-link>
        <p class="footer-text">© {{ new Date().getFullYear() }} Alkafeel.net</p>
      </div>

      <!-- ═══════════ MAP DIALOG ═══════════ -->
      <v-dialog v-model="map_dialog" max-width="900">
        <v-card class="dlg-card">
          <v-btn class="dlg-close" @click="map_dialog = false" icon dark small>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 5L5 15M5 5l10 10" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>
          </v-btn>
          <div class="dlg-body">
            <h3 class="dlg-title">{{ devAddress }}</h3>
            <p class="dlg-sub" v-if="add">{{ add }}</p>
            <p class="dlg-sub" v-if="phone">{{ phone }}</p>
            <div class="map-wrap">
              <GmapMap :options="mapOptions" :center="coordinates" :zoom="17" map-type-id="roadmap" style="width:100%;height:100%"><gmap-marker :position="coordinates"></gmap-marker></GmapMap>
            </div>
          </div>
          <v-card-actions class="pa-4"><v-spacer></v-spacer><v-btn class="dlg-close-btn" text @click="map_dialog = false">{{$t("close")}}</v-btn></v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Extra Dialog -->
      <v-dialog v-model="dialog2" max-width="900">
        <v-card class="dlg-card">
          <v-btn class="dlg-close" @click="dialog2 = false" icon dark small>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 5L5 15M5 5l10 10" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>
          </v-btn>
          <v-img src="https://alkafeel.net/news/images/attach/20100-5c2d693334689ceb63380b.png"></v-img>
          <v-card-actions class="pa-4"><v-spacer></v-spacer><v-btn class="dlg-close-btn" text @click="dialog2 = false">{{$t("close")}}</v-btn></v-card-actions>
        </v-card>
      </v-dialog>

    </v-app>
  </div>
</template>


<script>
import BreakingNews from '@/components/home/BreakingNews.vue';
import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css'
import videojs from 'video.js';
import 'videojs-youtube';
import bbCodeParser from 'js-bbcode-parser';
import 'video.js/dist/video-js.min.css';
import '@digitaltheatre/videojs-theme-dt/dist/theme/index.css';
import Swal from "sweetalert2";
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'VideoPlayer',
  data() {
    return {
      dialog: false,
      mobileMenu: false,
      languages: [
        { name: 'العربية' }, { name: 'English' }, { name: 'Deutsch' },
        { name: 'Français' }, { name: 'Türkçe' }, { name: 'Español' },
        { name: 'فارسی' }, { name: 'اردو' }, { name: 'Kiswahili' }
      ],
      tabs: 0,
      shour:'اَلسَّلامُ عَلَيْكَ يَا أَبَا عَبْدِ اللهِ ، اَلسَّلامُ عَلَيْكَ يَا بْنَ رَسُولِ اللهِ (اَلسَّلامُ عَلَيْكَ يَا خِيَرَةَ اللهِ وَابْنَ خِيَرَتِهِ ) اَلسَّلامُ عَلَيْكَ يَا بْنَ أَميرِ الْمُؤْمِنِينَ وَابْنَ سَيِّدِ الْوَصِيِّينَ ، اَلسَّلامُ عَلَيْكَ يَا بْنَ فاطِمَةَ سَيِّدَةِ نِسَاءِ الْعَالَمِينَ ، اَلسَّلامُ عَلَيْكَ يَا ثَأْرَ اللهِ وَابْنَ ثَأْرِهِ وَالْوِتْرَ الْمَوْتُورَ ، اَلسَّلامُ عَلَيْكَ وَعَلَى الْأَرْوَاحِ الَّتِي حَلَّتْ بِفِنَائِكَ ، عَلَيْكُم مِّنِّي جَمِيعاً سَلامُ اللهِ أَبَداً مَّا بَقِيتُ وَبَقِيَ اللَّيْلُ وَالنَّهَارُ ، يَا أَبَا عَبْدِ اللهِ لَقَدْ عَظُمَتِ الرَّزِيَّةُ وَجَلَّتْ ، وَعَظُمَتِ الْمُصِيبَةُ بِكَ عَلَى جَمِيعِ أَهْلِ الْإِسْلَامِ ، وَجَلَّتْ وَعَظُمَتْ مُصِيبَتُكَ فِي السَّمَاوَاتِ عَلَى جَمِيعِ أَهْلِ السَّمَاوَاتِ ، فَلَعَنَ اللهُ أُمَّةً أَسَّسَتْ أَسَاسَ الظُّلْمِ وَالْجَوْرِ عَلَيْكُمْ أَهْلَ الْبَيْتِ ، وَلَعَنَ اللهُ أُمَّةً دَفَعَتْكُمْ عَن مَّقامِكُمْ وَأَزالَتْكُمْ عَن مَّراتِبِكُمُ الَّتي رَتَّبَكُمُ اللهُ فِيهَا ، وَلَعَنَ اللهُ أُمَّةً قَتَلَتْكُمْ وَلَعَنَ اللهُ الْمُمَهِّدِينَ لَهُمْ بِالتَّمْكِينِ مِنْ قِتَالِكُمْ ، بَرِئْتُ إِلَى اللهِ وَإِلَيْكُمْ مِنْهُمْ وَمِنْ أَشْيَاعِهِمْ وَأَتْبَاعِهِمْ وَأَوْلِيَائِهِم ، يَا أَبَا عَبْدِ اللهِ إِنِّي سِلْمٌ لِمَنْ سَالَمَكُمْ وَحَرْبٌ لِّمَنْ حَارَبَكُمْ إِلَى يَوْمِ الْقِيَامَةِ ، وَلَعَنَ اللهُ آلَ زِيَادٍ وَّآلَ مَرْوَانَ ، وَلَعَنَ اللهُ بَنِي أُمَيَّةَ قَاطِبَةً ، وَّلَعَنَ اللهُ ابْنَ مَرْجَانَةَ ، وَلَعَنَ اللهُ عُمَرَ بْنَ سَعْدٍ ، وَّلَعَنَ اللهُ شِمْراً ، وَّلَعَنَ اللهُ أُمَّةً أَسْرَجَتْ وَأَلْجَمَتْ وَتَنَقَّبَتْ لِقِتَالِكَ ، بِأَبِي أَنْتَ وَأُمِّي لَقَدْ عَظُمَ مُصَابِي بِكَ ، فَأَسْأَلُ اللهَ الَّذِي أَكْرَمَ مَقَامَكَ وَأَكْرَمَنِي بِكَ أَن يَّرْزُقَنِي طَلَبَ ثَأْرِكَ مَعَ إِمَامٍ مَّنْصُورٍ مِنْ أَهْلِ بَيْتِ مُحَمَّدٍ ـ صَلَّى اللهُ عَلَيْهِ وَآلِهِ ـ ، اَللَّهُمَّ اجْعَلْنِي عِنْدَكَ وَجيهاً بِالْحُسَيْنِ ـ عَلَيْهِ السَّلامُ ـ فِي الدُّنْيا وَالْآخِرَةِ ، يَا أَبَا عَبْدِ اللهِ إِنِّي أَتَقَرَّبُ إِلى اللهِ وَإِلَى رَسُولِهِ وَإِلَى أَمِيرِ الْمُؤْمِنِينَ وَإِلَى فَاطِمَةَ وَإِلَى الْحَسَنِ وَإِلَيْكَ بِمُوَالاتِكَ وَبِالْبَرَاءَةِ [ مِمَّنْ قَاتَلَكَ وَنَصَبَ لَكَ الْحَرْبَ وَبِالْبَراءَةِ مِمَّنْ أَسَّسَ أَسَاسَ الظُّلْمِ وَالْجَوْرِ عَلَيْكُمْ وَأَبْرَأُ إِلَى اللهِ وَإِلَى رَسُولِهِ ] مِمَّنْ أَسَّسَ أَسَاسَ ذَلِكَ وَبَنَى عَلَيْهِ بُنْيَانَهُ وَجَرى فِي ظُلْمِهِ وَجَوْرِهِ عَلَيْكُمْ وَعَلَى أَشْيَاعِكُمْ ، بَرِئْتُ إِلَى اللهِ وَإِلَيْكُم مَِنْهُمْ ، وَأَتَقَرَّبُ إِلَى اللهِ ثُمَّ إِلَيْكُمْ بِمُوَالاتِكُمْ وَمُوَالاةِ وَلِيِّكُمْ وَبِالْبَرَاءَةِ مِنْ أَعْدَائِكُمْ وَالنَّاصِبِينَ لَكُمُ الْحَرْبَ وَبِالْبَرَاءَةِ مِنْ أَشْيَاعِهِمْ وَأَتْبَاعِهِمْ ، إِنِّي سِلْمٌ لِّمَنْ سَالَمَكُمْ وَحَرْبٌ لِّمَنْ حَارَبَكُمْ وَوَلِيٌّ لِّمَنْ وَالاكُمْ وَعَدُوٌّ لَِمَنْ عَادَاكُمْ ، فَأَسْأَلُ اللهَ الَّذِي أَكْرَمَنِي بِمَعْرِفَتِكُمْ وَمَعْرِفَةِ أَوْلِيَائِكُمْ وَرَزَقَنِيَ الْبَرَاءَةَ مِنْ أَعْدَائِكُمْ أَن يَّجْعَلَنِي مَعَكُمْ فِي الدُّنْيا وَالْآخِرَةِ ، وَأَن يُّثَبِّتَ لِي عِنْدَكُمْ قَدَمَ صِدْقٍ فِي الدُّنْيا وَالْآخِرَةِ ، وَأَسْأَلُهُ أَن يُّبَلِّغَنِيَ الْمَقَامَ الْمَحْمُودَ لَكُمْ عِنْدَ اللهِ ، وَأَن يَّرْزُقَني طَلَبَ ثَأْرِي مَعَ إِمَامِ هُدًى ظَاهِرٍ نَّاطِقٍ بِالْحَقِّ مِنْكُمْ ، وَأَسْألُ اللهَ بِحَقِّكُمْ وَبِالشَّأْنِ الَّذِي لَكُمْ عِنْدَهُ أَنْ يُعْطِيَنِي بِمُصَابِي بِكُمْ أَفْضَلَ مَا يُعْطِي مُصَاباً بِمُصِيبَتِهِ ، مُصِيبَةً مَّا أَعْظَمَهَا وَأَعْظَمَ رَزِيَّتَهَا فِي الْإِسْلامِ وَفِي جَمِيعِ السَّمَاوَاتِ وَالْأرْضِ ، اَللَّـهُمَّ اجْعَلْنِي فِي مَقَامِي هَذَا مِمَّنْ تَنَالُهُ مِنْكَ صَلَوَاتٌ وَّرَحْمَةٌ وَّمَغْفِرَةٌ ، اَللَّـهُمَّ اجْعَلْ مَحْيَايَ مَحْيَا مُحَمَّدٍ وَّآلِ مُحَمَّدٍ ، وَّمَمَاتِي مَمَاتَ مُحَمَّدٍ وََآلِ مُحَمَّدٍ ، اَللّّـهُمَّ إِنَّ هَذَا يَوْمٌ تَبَرَّكَتْ بِهِ بَنُو أُمَيَّةَ وَابْنُ آكِلَةِ الْأَكْبَادِ اللَّعِينُ بْنُ اللَّعِينِ عَلَى لِسَانِكَ وَلِسَانِ نَبِيِّكَ ـ صَلَّى اللهُ عَلَيْهِ وَآلِهِ ـ فِي كُلِّ مَوْطِنٍ وَّمَوْقِفٍ وَّقَفَ فِيهِ نَبِيُّكَ ـ صَلَّى اللهُ عَلَيْهِ وَآلِهِ ـ ، اَللَّـهُمَّ الْعَنْ أَبَا سُفْيَانَ وَمُعَاوِيَةَ وَيَزيدَ بْنَ مُعَاوِيَةَ عَلَيْهِم مِّنْكَ اللَّعْنَةُ أَبَدَ الْآبِدِينَ ، وَهَذَا يَوْمٌ فَرِحَتْ بِهِ آلُ زِيَادٍ وَآلَ مَرْوَانَ بِقَتْلِهِمُ الْحُسَيْنَ ـ صَلَواتُ اللهِ عَلَيْهِ ـ ، اَللَّـهُمَّ فَضَاعِفْ عَلَيْهِمُ اللَّعْنَ مِنْكَ وَالْعَذَابَ الْأَلِيمَ ، اَللَّـهُمَّ إِنِّي أَتَقَرَّبُ إِلَيْكَ فِي هَذَا الْيَوْمِ وَفِي مَوْقِفِي هَذَا وَأَيَّامِ حَيَاتِي بِالْبَرَاءَةِ مِنْهُمْ وَاللَّعْنَةِ عَلَيْهِمْ وَبِالْمُوَالاةِ لِنَبِيِّكَ وَآلِ نَبِيِّكَ ـ عَلَيْهِ وَعَلَيْهِمُ السَّلامُ ـ . ثمّ تقول مائة مرّة : اَللَّـهُمَّ الْعَنْ أَوَّلَ ظَالِمٍ ظَلَمَ حَقَّ مُحَمَّدٍ وَّآلِ مُحَمَّدٍ وَآخِرَ تَابِعٍ لَهُ عَلَى ذلِكَ ، اَللّـَهُمَّ الْعَنِ الْعِصَابَةَ الَّتي جَاهَدَتِ الْحُسَيْنَ ـ عَلَيْهِ السَّلَامُ ـ وَشَايَعَتْ وَبَايَعَتْ وَتَابَعَتْ عَلَى قَتْلِهِ ، اَللَّـهُمَّ الْعَنْهُمْ جَمِيعاً . ثمّ تقول مائة مرّة : اَلسَّلامُ عَلَيْكَ يَا أَبَا عَبْدِ اللهِ وَعَلَى الْأَرْوَاحِ الَّتِي حَلَّتْ بِفِنَائِكَ ، عَلَيْكَ مِنِّي سَلامُ اللهِ أَبَداً مَّا بَقِيتُ وَبَقِيَ اللَّيْلُ وَالنَّهَارُ ، وَلا جَعَلَهُ اللهُ آخِرَ الْعَهْدِ مِنِّي لِزِيَارَتِكُمْ ، اَلسَّلامُ عَلَى الْحُسَيْنِ ، وَعَلَى عَلِيِّ بْنِ الْحُسَيْنِ وَعَلَى أَوْلادِ الْحُسَيْنِ وَعَلَى أَصْحَابِ الْحُسَيْنِ . ثمّ تقول : اَللَّـهُمَّ خُصَّ أَنْتَ أَوَّلَ ظَالِمٍ بِاللَّعْنِ مِنِّي ، وَابْدَأْ بِهِ أَوَّلاً ، ثُمَّ الْعَنِ الثَّانيَ وَالثَّالِثَ وَالرَّابِعَ ، اَللّـَهُمَّ الْعَنْ يَزيدَ خَامِساً ، وَالْعَنْ عُبَيْدَ اللهِ بْنَ زِيَادٍ وَّابْنَ مَرْجانَةَ وَعُمَرَ بْنَ سَعْدٍ وَّشِمْراً وَآلَ أَبِي سُفْيَانَ وَآلَ زِيادٍ وََآلَ مَرْوَانَ إِلَى يَوْمِ الْقِيَامَةِ . ثمّ تسجد وتقُول : اَللَّـهُمَّ لَكَ الْحَمْدُ حَمْدَ الشَّاكِرِينَ لَكَ عَلَى مُصَابِهِمْ ، اَلْحَمْدُ للهِ عَلَى عَظِيمِ رَزِيَّتِي ، اَللَّـهُمَّ ارْزُقْنِي شَفَاعَةَ الْحُسَيْنِ يَوْمَ الْوُرُودِ ، وَثَبِّتْ لِي قَدَمَ صِدْقٍ عِنْدَكَ مَعَ الْحُسَيْنِ وَأَصْحَابِ الْحُسَيْنِ اَلَّذِينَ بَذَلُوا مُهَجَهُمْ دُونَ الْحُسَيْنِ عَلَيْهِ السَّلامُ .',
      open_ash: false, amd_dialog: false, is_search: false, pageCount: 0, page: 1, text: '',
      isMuted: true, video: null, dialog: false, dialog2: false, map_dialog: false,
      mapOptions: { zoomControl: true, mapTypeControl: true, scaleControl: true, streetViewControl: true, rotateControl: true, fullscreenControl: true, disableDefaultUI: false },
      coordinates: {}, devAddress: '', add: '', phone: '', divInfo: [], live: [], atabat: [],
      liveDist: '', Amd: '', activeId: 1, Guids: [], PlacesCat: [], PlacesCats: [], secCat: '',
      yt: false, yt_src: '', search: '', statistics: 0, baseDomain: window.location.hostname,
      ssc: [], playerLoading: true, axiosLoad: true,
      attrs: { class: 'sm-4', boilerplate: false, elevation: 2 },
      zeara_i: { name: '', email: '', ab: '', save: 'save' },
      zyaraData: [], zyaraText: '', loader: null, loading: false, player: null,
      videoOptions: {
        autoplay: 'any', poster: '', controls: true, fill: true,
        controlBar: { remainingTimeDisplay: false, currentTimeDisplay: false, timeDivider: false, durationDisplay: true },
        autoSetup: false, techOrder: ['youtube', 'html5'],
        sources: [{ src: "https://stream.alkafeel.net/live/alkafeel/rAa5PGot1/manifest.m3u8", type: "application/x-mpegURL" }],
      },
      rules: {
        required: value => !!value || this.$t("required_field"),
        min: (v) => v.length >= 3 || this.$t("three_letters"),
        email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t("alert_wrong_email"),
      },
      events: null, today: 1, modal_data: null, hash: null, langs: [],
      dir: 'rtl', lang: 'ar', logo: 'logo6.svg', lang_src: 'uploads',
      khudam: [], currentCard: 1,
      cardData: [{ title: "", description: "", image: "" }, { title: "", description: "", image: "" }, { title: "", description: "", image: "" }],
      cards: [],
      settings: {
        "dots": false, "arrows": true, "infinite": true, "slidesToScroll": 3, "slidesToShow": 3, "centerPadding": "20px",
        "rtl": this.dir == 'rtl' ? true : false,
        "responsive": [
          { "breakpoint": 1024, "settings": { "slidesToShow": 3, "slidesToScroll": 3 } },
          { "breakpoint": 600, "settings": { "slidesToShow": 2, "slidesToScroll": 2 } },
          { "breakpoint": 480, "settings": { "slidesToShow": 1, "slidesToScroll": 1 } }
        ]
      }
    };
  },
  watch: {
    loader() { const l = this.loader; this[l] = !this[l]; setTimeout(() => (this[l] = false), 3000); this.loader = null; },
    axiosLoad(n, o) {
      if (!n && this.yt) { this.live_ini('yt'); this.$refs.videoPlayer.load(); setTimeout(() => this.loadPlayer(), 1000); setTimeout(() => this.playerLoading = false, 500); }
      else { this.live_ini('native'); this.$refs.videoPlayer.load(); setTimeout(() => this.loadPlayer(), 1000); setTimeout(() => this.playerLoading = false, 500); }
      this.live_atabat();
    }
  },
  components: { BreakingNews, VueSlickCarousel },
  directives: {},
  computed: {
    currentTitle() {
      if (!Array.isArray(this.cardData) || this.cardData.length === 0) { return ''; }
      const current = this.cardData[this.currentCard % this.cardData.length];
      return current ? current.title : '';
    },
    currentDescription() {
      if (!Array.isArray(this.cardData) || this.cardData.length === 0) { return ''; }
      const current = this.cardData[this.currentCard % this.cardData.length];
      return current ? current.description : '';
    }
  },
  beforeCreate() {
    document.title = this.$t("visitor_guide");
    this.$axios.get("zyara/GetDetails").then(d => { this.zyaraData = d.data.Data; });
    this.$axios.get("live/zyara").then(d => { this.zyaraText = d.data && d.data[0] ? d.data[0].text : ''; });
    this.$axios.get("get_events").then(d => {
      const firstEvent = d.data && d.data.Data && d.data.Data[0] ? d.data.Data[0] : null;
      this.events = firstEvent ? firstEvent.event : null;
      this.today = firstEvent ? firstEvent.date_d : 1;
    });
  },
  created() {
    this.get_langs(); this.getPlace(3); this.GetPlacesCat(); this.GET_Guid(); this.lang_fn(); this.ashabfn(20); this.khudamfn(15);
    this.$axios.get("https://alkafeel.net/women_library/api/visitor_num_mh");
    this.$axios.get("https://alkafeel.net/main_bg/data/live_proxy.php?t=" + Date.now()).then(d => {
      if (d.status === 200 && d.data.live) { this.yt_src = d.data.videoId; this.yt = true; this.axiosLoad = false; }
      else { this.axiosLoad = false; }
    });
    if (this.$route.hash !== '') { this.hash = this.$route.hash.replace('#', ''); }
    var dir; let params = (new URL(document.location)).searchParams; var lang = params.get("lang");
    if (lang == 'en' || lang == 'de' || lang == 'fr' || lang == 'sw' || lang == 'tr') { dir = 'ltr'; } else { dir = 'rtl'; }
    this.$store.dispatch("UpdateLang", { lang: lang, dir: dir });
  },
  mounted() {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) { var video = document.getElementById("video-background"); var image = document.createElement("img"); image.src = "/assets/img/moharam/main-bg-3.jpg"; video.parentNode.replaceChild(image, video); }
    const theme = localStorage.getItem("dark_theme");
    if (theme) { if (theme === "true") { this.$vuetify.theme.dark = true; } else { this.$vuetify.theme.dark = false; } }
    else if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) { this.$vuetify.theme.dark = true; localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString()); }
    else { this.$vuetify.theme.dark = false; localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString()); }
    this.video = this.$refs.videoss;
    this.showCard(this.currentCard);
    var nextBtn = document.getElementById('next'); if (nextBtn) { nextBtn.addEventListener('click', () => { this.showNext(); }); }
    var prevBtn = document.getElementById('prev'); if (prevBtn) { prevBtn.addEventListener('click', () => { this.showPrev(); }); }
  },
  updated() { this.lang_dt(this.$route.query.lang); },
  beforeDestroy() { if (this.player) { this.player.dispose(); } },
  methods: {
    route_rdr(code) { location.replace(location.protocol + '//' + location.host + location.pathname + '?lang=' + code); },
    lang_dt(url) { if (url === undefined) { this.lang_ck('ar'); return; } this.lang_ck(url); },
    get_langs() { this.$axios.get("https://alkafeel.net/main_bg/data/core_langs_main.json").then((res) => { this.languages = res.data; }); },
    bbcode(x) { return bbCodeParser.parse(this.stripHTML(x)); },
    stripHTML(value) { const div = document.createElement('div'); div.innerHTML = value; const text = div.textContent || div.innerText || ''; return text; },
    open_ashs() { this.open_ash = true; },
    searchs() { this.is_search = true; this.next(1); },
    ashabfn(limit) {
      this.$axios.get("ashura/0/" + limit).then((d) => {
        this.cardData = Array.isArray(d.data) && d.data.length ? d.data : [{ title: "", description: "", image: "" }];
        this.currentCard = 0;
        this.showCard(this.currentCard);
      });
    },
    khudamfn(limit) { this.$axios.get("ashura/1/" + limit).then((d) => { this.khudam = d.data; }); },
    next(page) {
      if (this.is_search == true) { this.$axios.get("Guid/search/" + this.search + '?page=' + page).then((d) => { this.Guids = d.data.data.data; this.last_page = d.data.data.last_page; this.pageCount = d.data.data.last_page; }); }
      else { this.$axios.get("Guid/getplacesbycat/" + this.secCat + '?page=' + page).then((d) => { this.Guids = d.data.data.data; this.last_page = d.data.data.last_page; this.pageCount = d.data.data.last_page; }); }
    },
    getPlace(id) { this.secCat = id; this.next(this.page, id); },
    toggleSound() { this.isMuted = !this.isMuted; this.video.muted = this.isMuted; this.player.pause(); },
    theFormat(number) { return number.toFixed(0); },
    scrollToSection(sectionId) { var section = document.getElementById(sectionId); if (section) { section.scrollIntoView({ behavior: 'smooth' }); } },
    show(y, a, p, l, lo) { this.coordinates = { lat: parseFloat(l), lng: parseFloat(lo) }; this.devAddress = y; this.add = a; this.phone = p; this.map_dialog = true; },
    format_coordinates(x) { var i = x.split(','); return { lat: parseFloat(i[0]), lng: parseFloat(i[1]) }; },
    live_ini(type) {
      this.$axios.get("live/all").then((d) => {
        this.live = d.data;
        if (type === 'yt') { this.videoOptions.sources[0].src = '//www.youtube.com/watch?v=' + this.yt_src; this.videoOptions.sources[0].type = 'video/youtube'; }
        else { this.videoOptions.sources[0].src = d.data[0]['src']; this.videoOptions.sources[0].type = 'application/x-mpegURL'; }
        this.videoOptions.poster = 'https://alkafeel.net/live/images/' + d.data[0]['pic']; this.liveDist = d.data[0]['title']; this.activeId = d.data[0]['id'];
      });
    },
    GetPlacesCat() {
      this.$axios.get("Guid/placescat").then((d) => {
        this.PlacesCats = Array.isArray(d.data) ? d.data : [];
      });
    },
    GET_Guid() { this.$axios.get("Guid").then((d) => { this.Guids = d.data.data.data; }); if (this.hash) setTimeout(() => this.scrollToSection(this.hash), 2000); },
    live_atabat() { this.$axios.get("live/atabat").then((d) => { this.atabat = d.data; }); if (this.hash) setTimeout(() => this.scrollToSection(this.hash), 2000); },
    playSrc(src, pic, title, id, type = 'application/x-mpegURL', atabat = false) {
      if (this.yt && !atabat) { src = '//www.youtube.com/watch?v=' + this.yt_src; type = 'video/youtube'; }
      this.player.poster('https://alkafeel.net/live/images/' + pic); this.player.src({ type: type, src: src }); this.liveDist = title; this.activeId = id; this.player.play();
    },
    loadPlayer() { this.player = videojs(this.$refs.videoPlayer, this.videoOptions); },
    zyara_send() {
      if (this.$refs.form.validate()) {
        var formdata = new FormData(); formdata.append("name", this.zeara_i.name); formdata.append("ab", this.zeara_i.ab); formdata.append("save", "save"); formdata.append("email", this.zeara_i.email);
        this.loader = 'loading';
        this.$axios({ method: 'post', url: 'https://alkafeel.net/zyara/Avdasdw/1352897989/post', data: formdata }).then(res => {
          this.zeara_i = {};
          Swal.fire({ position: 'center', icon: 'success', title: this.$t("zeara_result"), showConfirmButton: false, timer: 2000 });
        });
      }
    },
    data_tbl(id) { this.$axios.get("GetMawakeb/day/" + id).then(d => { this.divInfo = d.data.Data; this.dialog = true; }); },
    data_tbl2() { this.dialog2 = true; },
    lang_fn() { this.$axios.get("https://alkafeel.net/main_bg/data/core_langs_main.json").then((data) => { this.langs = data.data; }); },
    lang_ck(code) {
      this.langs.forEach((element, index) => {
        if (element.code === code) { this.lang = code; this.$i18n.locale = code; this.dir = element.dir == '1' ? 'rtl' : 'ltr'; this.logo = element.logo; if (code !== 'ar') this.lang_src = 'src/svg'; this.$vuetify.rtl = this.dir === 'rtl' ? true : false; this.$axios.defaults.headers.get['lang'] = this.$i18n.locale; }
      });
    },
    showCard(cardNumber) {
      if (!Array.isArray(this.cardData) || this.cardData.length === 0) {
        this.cards = [];
        return;
      }
      // Add slide animation to cards and text
      var wrap = document.querySelector('.ashab-cards-wrap');
      var info = document.querySelector('.ashab-info');
      if (wrap) { wrap.classList.remove('slide-anim'); void wrap.offsetWidth; wrap.classList.add('slide-anim'); }
      if (info) { info.classList.remove('slide-anim'); void info.offsetWidth; info.classList.add('slide-anim'); }
      this.cards = [ this.cardData[(cardNumber - 1 + this.cardData.length) % this.cardData.length], this.cardData[cardNumber % this.cardData.length], this.cardData[(cardNumber + 1) % this.cardData.length] ];
    },
    showNext() {
      if (!Array.isArray(this.cardData) || this.cardData.length === 0) { return; }
      this.currentCard = (this.currentCard + 1) % this.cardData.length;
      this.showCard(this.currentCard);
    },
    showPrev() {
      if (!Array.isArray(this.cardData) || this.cardData.length === 0) { return; }
      this.currentCard = (this.currentCard - 1 + this.cardData.length) % this.cardData.length;
      this.showCard(this.currentCard);
    },
    openModal(modalId, amd) { this.amd_dialog = true; this.Amd = amd; },
    closeModal(modalId) { document.getElementById(modalId).style.display = "none"; },
    outsideClick(event) { if (event.target.classList.contains('modal')) { event.target.style.display = "none"; } }
  }
}
</script>


<style>
/* ══════════════════════════════════════════════════════ */
/* GLOBAL RESET & VARIABLES                             */
/* ══════════════════════════════════════════════════════ */
.muharram-page { overflow-x: hidden !important; width: 100% !important; max-width: 100vw !important; }
.muharram-page .v-application { font-family: 'Cairo', 'Noto Kufi Arabic', sans-serif !important; width: 100% !important; max-width: 100vw !important; }
.muharram-page .v-application--wrap { width: 100% !important; max-width: 100vw !important; min-height: auto !important; }

/* ══════════════════════════════════════════════════════ */
/* VIDEO BACKGROUND                                     */
/* ══════════════════════════════════════════════════════ */
.bg-video-wrap {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; overflow: hidden;
}
.bg-video-wrap video {
  width: 100%; height: 100%; object-fit: cover;
}
.bg-overlay {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%;
  background:linear-gradient(180deg, rgb(10 10 10 / 13%) 0%, rgb(15 15 15 / 24%) 40%, rgb(10 10 10 / 58%) 100%);
}

/* ══════════════════════════════════════════════════════ */
/* TOP HEADER                                           */
/* ══════════════════════════════════════════════════════ */
.top-header {
  position: fixed; top: 0; left: 0; right: 0; z-index: 100;
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 32px;
  background: rgba(15,15,15,0.92);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(192,57,43,0.3);
  width: 100%; box-sizing: border-box;
}
.header-logo { display: flex; align-items: center; text-decoration: none; }
.header-logo-img { height: 44px; max-width: 180px; object-fit: contain; }
.header-nav { display: flex; gap: 6px; align-items: center; }
.nav-link {
  display: flex; align-items: center; gap: 6px;
  padding: 8px 14px; border-radius: 8px;
  color: #fff !important; font-size: 13px; font-weight: 600;
  text-decoration: none; cursor: pointer;
  transition: all 0.3s ease;
}
.nav-link:hover { color: #e74c3c !important; background: rgba(192,57,43,0.15); }
.nav-link:active { color: #c0392b !important; }
.nav-link span { color: #fff !important; }
.nav-link:hover span { color: #e74c3c !important; }
.nav-link img, .nav-link svg { opacity: 0.9; transition: 0.3s; filter: brightness(0) invert(1); }
.nav-link:hover img, .nav-link:hover svg { opacity: 1; filter: brightness(0) saturate(1) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%); }
.header-actions { display: flex; gap: 8px; align-items: center; }
.h-action-btn {
  width: 40px; height: 40px; border-radius: 10px; border: 1px solid rgba(255,255,255,0.15);
  background: rgba(255,255,255,0.05); cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all 0.3s ease;
}
.h-action-btn:hover { background: rgba(192,57,43,0.3); border-color: rgba(192,57,43,0.5); }

/* ══════════════════════════════════════════════════════ */
/* MOBILE NAV                                           */
/* ══════════════════════════════════════════════════════ */
.mobile-nav {
  position: fixed; top: 64px; left: 0; right: 0; z-index: 99;
  background: rgba(15,15,15,0.97);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(192,57,43,0.3);
  display: flex; flex-direction: column;
  padding: 8px 0;
  animation: slideDown 0.3s ease-out;
}
@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
.mobile-nav-link {
  display: flex; align-items: center; gap: 12px;
  padding: 14px 24px; color: #fff !important;
  text-decoration: none; font-size: 15px; font-weight: 600;
  cursor: pointer; transition: all 0.2s ease;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}
.mobile-nav-link:hover { background: rgba(192,57,43,0.15); }
.mobile-nav-link:last-child { border-bottom: none; }

/* ══════════════════════════════════════════════════════ */
/* MAIN CONTENT                                         */
/* ══════════════════════════════════════════════════════ */
.main-content {
  position: relative; z-index: 1;
  max-width: 1200px; margin: 0 auto;
  padding: 80px 24px 0 24px;
  width: 100%; box-sizing: border-box;
}

/* ══════════════════════════════════════════════════════ */
/* SECTIONS COMMON                                      */
/* ══════════════════════════════════════════════════════ */
.sec {
  padding: 60px 0;
  animation: fadeInUp 0.6s ease-out both;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}
.sec-wrap { position: relative; }
.sec-head {
  text-align: center; margin-bottom: 40px;
}
.sec-ornament {
  display: flex; align-items: center; justify-content: center; gap: 12px; margin-bottom: 12px;
}
.orn-line {
  display: block; width: 60px; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(192,57,43,0.6), transparent);
}
.orn-icon { height: 24px; opacity: 0.7; }
.sec-title-link { text-decoration: none; }
.sec-title {
  font-size: 28px; font-weight: 800; color: #fff;
  letter-spacing: 0.5px; margin: 0;
  text-shadow: 0 2px 10px rgba(0,0,0,0.5);
}
.sec-title-link:hover .sec-title { color: #e74c3c; transition: 0.3s; }

/* ══════════════════════════════════════════════════════ */
/* ZYARA SECTION                                        */
/* ══════════════════════════════════════════════════════ */
.zyara-content {
  background: rgba(25,25,25,0.8);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px; padding: 32px;
  backdrop-filter: blur(10px);
}
.zyara-sub {
  text-align: center; color: rgba(255,255,255,0.85);
  font-size: 20px; font-weight: 700; margin-bottom: 24px;
  font-family: 'cairo_bold', 'Cairo', sans-serif;
}
.zyara-form .zyara-row {
  display: flex; gap: 12px; align-items: stretch;
  flex-wrap: wrap;
}
.zyara-field { flex: 1; min-width: 200px; }
.zyara-field .v-input__slot {
  background: rgba(255,255,255,0.08) !important;
  border: 1px solid rgba(255,255,255,0.12) !important;
  border-radius: 10px !important;
}
.zyara-field input { color: #fff !important; }
.zyara-btn {
  min-height: 48px !important; padding: 0 28px !important;
  background: linear-gradient(135deg, #c0392b, #96281b) !important;
  color: #fff !important; border-radius: 10px !important;
  font-weight: 700 !important; font-size: 15px !important;
  letter-spacing: 0.3px; text-transform: none !important;
  transition: all 0.3s ease !important;
  display: flex; align-items: center; gap: 8px;
}
.zyara-btn:hover { transform: translateY(-2px); }

/* ══════════════════════════════════════════════════════ */
/* LIVE SECTION                                         */
/* ══════════════════════════════════════════════════════ */
.live-grid {
  display: grid; grid-template-columns: 1fr 300px; gap: 20px;
}
.live-player { min-height: 0; }
.player-frame {
  width: 100%; height: 450px;
  border-radius: 12px; overflow: hidden;
  background: rgba(0,0,0,0.6);
  box-shadow: 0 8px 32px rgba(0,0,0,0.4);
}
.live-channels { display: flex; flex-direction: column; }
.channels-list {
  display: flex; flex-direction: column; gap: 8px;
  max-height: 450px; overflow-y: auto;
  padding-left: 4px;
}
.channels-list::-webkit-scrollbar { width: 4px; }
.channels-list::-webkit-scrollbar-thumb { background: rgba(192,57,43,0.5); border-radius: 4px; }
.ch-card {
  display: flex; align-items: center; gap: 10px;
  padding: 12px 16px; border-radius: 10px;
  background: rgba(30,30,30,0.9);
  border: 1px solid rgba(255,255,255,0.06);
  cursor: pointer; transition: all 0.3s ease;
  min-height: 50px;
}
.ch-card:hover { background: rgba(192,57,43,0.25); border-color: rgba(192,57,43,0.4); }
.ch-active {
  background: linear-gradient(135deg, rgba(192,57,43,0.4), rgba(150,40,27,0.3)) !important;
  border-color: rgba(192,57,43,0.6) !important;
  box-shadow: 0 0 15px rgba(192,57,43,0.2);
}
.ch-icon { color: #B1BD52; display: flex; align-items: center; }
.ch-active .ch-icon { color: #fff; }
.ch-name { color: rgba(255,255,255,0.85); font-size: 13px; font-weight: 600; }
.ch-active .ch-name { color: #fff; }

/* ══════════════════════════════════════════════════════ */
/* EVENTS SECTION                                       */
/* ══════════════════════════════════════════════════════ */
.events-card {
  background: rgba(25,25,25,0.8);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 12px; padding: 32px;
  backdrop-filter: blur(10px);
}
.events-text {
  color: rgba(255,255,255,0.9); font-size: 18px;
  text-align: center; white-space: pre-wrap;
  line-height: 1.8; margin: 0;
}

/* ══════════════════════════════════════════════════════ */
/* ASHAB (COMPANIONS) SECTION                           */
/* ══════════════════════════════════════════════════════ */
.ashab-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 40px;
  align-items: center; min-height: 400px;
}
.ashab-info { padding: 20px; }
.ashab-name {
  font-size: 32px; font-weight: 800; color: #e74c3c;
  margin-bottom: 16px; line-height: 1.4;
  text-shadow: 0 2px 8px rgba(0,0,0,0.3);
}
.ashab-desc {
  color: rgba(255,255,255,0.8); font-size: 16px;
  line-height: 1.8; white-space: pre-wrap; margin: 0;
}
.ashab-cards-area {
  display: flex; justify-content: center; align-items: center;
  min-height: 380px;
}
.ashab-cards-wrap {
  position: relative; width: 360px; height: 380px;
}
.ashab-card {
  position: absolute; width: 300px; height: 360px;
  border-radius: 16px; overflow: hidden;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0 10px 40px rgba(0,0,0,0.5);
  animation: cardFadeIn 0.6s ease-out both;
}
@keyframes cardFadeIn {
  0% { opacity: 0; transform: scale(0.85) translateY(20px); }
  100% { opacity: 1; }
}
.slide-anim .ashab-card {
  animation: slideCard 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.slide-anim .ashab-card:nth-child(1) { animation-delay: 0s; }
.slide-anim .ashab-card:nth-child(2) { animation-delay: 0.08s; }
.slide-anim .ashab-card:nth-child(3) { animation-delay: 0.16s; }
@keyframes slideCard {
  0% { opacity: 0; transform: translateX(40px) scale(0.9); }
  100% { opacity: 1; }
}
.slide-anim .ashab-info {
  animation: slideText 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@keyframes slideText {
  0% { opacity: 0; transform: translateX(-30px); }
  100% { opacity: 1; transform: translateX(0); }
}
.slide-anim .ashab-name { animation: fadeSlideUp 0.5s 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both; }
.slide-anim .ashab-desc { animation: fadeSlideUp 0.5s 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both; }
@keyframes fadeSlideUp {
  0% { opacity: 0; transform: translateY(15px); }
  100% { opacity: 1; transform: translateY(0); }
}
.ashab-card img { width: 100%; height: 100%; object-fit: cover; }
.ashab-card-main {
  width: 340px; height: 380px;
}
.ashab-card-overlay {
  position: absolute; bottom: 0; left: 0; right: 0;
  padding: 16px;
  background: linear-gradient(transparent, rgba(0,0,0,0.8));
  color: #fff; text-align: center;
  font-weight: 700; font-size: 16px;
}
.ashab-nav {
  display: flex; align-items: center; justify-content: center;
  gap: 24px; margin-top: 24px;
}
.arr-btn {
  width: 48px; height: 48px; border-radius: 12px;
  border: 1px solid rgba(192,57,43,0.4);
  background: rgba(192,57,43,0.15);
  color: #e74c3c; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all 0.3s ease;
}
.arr-btn:hover { background: rgba(192,57,43,0.4); color: #fff; transform: scale(1.05); }
.ashab-counter {
  display: flex; align-items: center; gap: 4px;
  color: rgba(255,255,255,0.6); font-size: 16px; font-weight: 600;
}
.ctr-cur { color: #e74c3c; font-size: 22px; }
.ctr-sep { margin: 0 2px; }

/* ══════════════════════════════════════════════════════ */
/* KHDHAM (SERVANTS) SECTION                            */
/* ══════════════════════════════════════════════════════ */
.sec-khdham { position: relative; overflow: visible; }
.watermark-text {
  position: absolute; top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  font-size: clamp(80px, 15vw, 200px); font-weight: 900;
  color: rgba(255,255,255,0.02);
  pointer-events: none; user-select: none;
  white-space: nowrap; z-index: 0;
}
.kh-card {
  padding: 8px; position: relative; z-index: 1;
}
.kh-offset { transform: translateY(8%); }
.kh-inner {
  position: relative; border-radius: 16px; overflow: hidden;
  cursor: pointer; aspect-ratio: 3/4;
  box-shadow: 0 8px 30px rgba(0,0,0,0.4);
  transition: all 0.4s ease;
}
.kh-inner:hover { transform: translateY(-5px); box-shadow: 0 12px 40px rgba(192,57,43,0.3); }
.kh-img {
  width: 100%; height: 100%; object-fit: cover;
  filter: grayscale(60%); transition: filter 0.5s ease;
}
.kh-inner:hover .kh-img { filter: grayscale(0%); }
.kh-info {
  position: absolute; bottom: 0; left: 0; right: 0;
  padding: 20px 16px;
  background: linear-gradient(transparent, rgba(0,0,0,0.85));
}
.kh-name {
  color: #fff; font-size: 16px; font-weight: 700;
  text-align: center; margin: 0;
}
.kh-shine {
  position: absolute; top: 0; left: -100%; width: 60%; height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent);
  transition: left 0.6s ease;
}
.kh-inner:hover .kh-shine { left: 100%; }

/* Slick arrows - styled directly on slick elements */
.sec-khdham .slick-prev,
.sec-khdham .slick-next {
  width: 44px !important;
  height: 44px !important;
  border-radius: 50% !important;
  background: #c0392b !important;
  color: #fff !important;
  z-index: 10 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 4px 15px rgba(0,0,0,0.3) !important;
  transition: all 0.3s ease !important;
}
.sec-khdham .slick-prev:hover,
.sec-khdham .slick-next:hover {
  background: #e74c3c !important;
  transform: translateY(-50%) scale(1.1) !important;
}
.sec-khdham .slick-prev:focus,
.sec-khdham .slick-next:focus {
  background: #c0392b !important;
}
.sec-khdham .slick-prev { left: 10px !important; }
.sec-khdham .slick-next { right: 10px !important; }
[dir="rtl"] .sec-khdham .slick-prev { left: auto !important; right: 10px !important; }
[dir="rtl"] .sec-khdham .slick-next { right: auto !important; left: 10px !important; }
.sec-khdham .slick-prev::before,
.sec-khdham .slick-next::before {
  font-family: 'Material Design Icons', 'mdi' !important;
  font-size: 24px !important;
  color: #fff !important;
  opacity: 1 !important;
  -webkit-font-smoothing: antialiased !important;
  line-height: 1 !important;
}
.sec-khdham .slick-prev::before { content: '\F0141' !important; }
.sec-khdham .slick-next::before { content: '\F0142' !important; }
[dir="rtl"] .sec-khdham .slick-prev::before { content: '\F0142' !important; }
[dir="rtl"] .sec-khdham .slick-next::before { content: '\F0141' !important; }
.sec-khdham .slick-slider { overflow: visible !important; margin-bottom: 16px; }
.sec-khdham .slick-list { overflow: visible !important; margin: 0 30px; }

.ashura-btn-wrap {
  margin-top: 24px; text-align: center;
  position: relative; z-index: 5;
}
.ashura-btn {
  display: inline-flex; align-items: center; justify-content: center;
  padding: 18px 40px; border-radius: 12px; border: none;
  background: linear-gradient(135deg, #c0392b, #96281b);
  color: #fff; font-size: 16px; font-weight: 700;
  cursor: pointer; text-align: center;
  transition: all 0.3s ease; max-width: 600px;
  white-space: normal; line-height: 1.6;
}
.ashura-btn:hover { transform: translateY(-2px);  }

/* ══════════════════════════════════════════════════════ */
/* VISITOR GUIDE SECTION                                */
/* ══════════════════════════════════════════════════════ */
.visitor-card {
  background: rgba(25,25,25,0.8);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px; padding: 32px;
  backdrop-filter: blur(10px);
}
.visitor-search { margin-bottom: 24px; }
.visitor-input .v-input__slot {
  background: rgba(255,255,255,0.06) !important;
  border: 1px solid rgba(255,255,255,0.12) !important;
  border-radius: 12px !important;
}
.visitor-input input { color: #fff !important; }
.visitor-search-btn {
  background: #14A79D !important; border-radius: 8px !important;
  padding: 8px 16px !important; display: flex; align-items: center; gap: 6px;
  color: #fff !important; font-size: 13px !important; font-weight: 600 !important;
}
.visitor-tabs {
  display: flex; gap: 6px; margin-bottom: 24px;
  overflow-x: auto; padding-bottom: 4px;
  flex-wrap: wrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: rgba(192,57,43,0.4) transparent;
}
.visitor-tabs::-webkit-scrollbar { height: 4px; }
.visitor-tabs::-webkit-scrollbar-track { background: transparent; }
.visitor-tabs::-webkit-scrollbar-thumb { background: rgba(192,57,43,0.4); border-radius: 4px; }
.vtab {
  padding: 10px 20px; border-radius: 8px;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.7); font-size: 13px; font-weight: 600;
  cursor: pointer; transition: all 0.3s ease; white-space: nowrap;
}
.vtab:hover { background: rgba(192,57,43,0.2); border-color: rgba(192,57,43,0.4); color: #fff; }
.vtab-active {
  background: linear-gradient(135deg, #c0392b, #96281b) !important;
  border-color: #c0392b !important; color: #fff !important;
}
.visitor-body-title {
  color: rgba(255,255,255,0.8); font-size: 20px; font-weight: 700;
  margin-bottom: 20px;
}
.places-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
}
.place-card {
  display: flex; align-items: center; gap: 12px;
  padding: 16px; border-radius: 12px;
  background: rgba(20,20,20,0.8);
  border: 1px solid rgba(255,255,255,0.06);
  cursor: pointer; transition: all 0.3s ease;
}
.place-card:hover {
  background: rgba(192,57,43,0.15);
  border-color: rgba(192,57,43,0.3);
  transform: translateY(-2px);
}
.place-icon { flex-shrink: 0; display: flex; align-items: center; }
.place-info { flex: 1; min-width: 0; }
.place-name { color: #fff; font-size: 14px; font-weight: 700; margin: 0 0 4px; }
.place-addr { color: rgba(255,255,255,0.5); font-size: 12px; }
.place-arrow {
  flex-shrink: 0; color: rgba(255,255,255,0.3);
  transition: 0.3s;
}
.place-card:hover .place-arrow { color: #e74c3c; transform: translateX(-4px); }
.visitor-pag { margin-top: 24px; display: flex; justify-content: center; }

/* ══════════════════════════════════════════════════════ */
/* MODALS & DIALOGS                                     */
/* ══════════════════════════════════════════════════════ */
.dlg-card {
  background: rgba(25,25,25,0.95) !important;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 16px !important;
  backdrop-filter: blur(20px);
  position: relative;
}
.dlg-close {
  position: absolute; top: 12px; left: 12px; z-index: 10;
  background: rgba(192,57,43,0.6) !important;
  border-radius: 8px !important;
}
.dlg-body { padding: 32px; }
.dlg-title {
  color: #fff; font-size: 22px; font-weight: 800;
  margin-bottom: 16px; line-height: 1.5;
}
.dlg-sub { color: rgba(255,255,255,0.7); font-size: 15px; margin-bottom: 8px; }
.dlg-divider {
  width: 60px; height: 3px; margin: 16px 0;
  background: linear-gradient(90deg, #c0392b, transparent);
  border-radius: 2px;
}
.dlg-label { color: rgba(255,255,255,0.6); font-size: 14px; font-weight: 600; margin-bottom: 12px; }
.dlg-zyara-text {
  color: rgba(255,255,255,0.85); font-size: 15px;
  line-height: 2; white-space: pre-wrap;
  padding: 20px; border-radius: 12px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
  max-height: 500px; overflow-y: auto;
}
.dlg-profile {
  display: flex; align-items: center; gap: 16px; margin-bottom: 16px;
}
.dlg-avatar {
  width: 64px; height: 64px; border-radius: 50%;
  object-fit: cover; border: 2px solid rgba(192,57,43,0.4);
}
.dlg-profile-name { color: #fff; font-size: 20px; font-weight: 700; margin: 0; }
.dlg-text {
  color: rgba(255,255,255,0.8); font-size: 15px;
  line-height: 1.8; white-space: pre-wrap;
}
.dlg-close-btn {
  color: #e74c3c !important; font-weight: 600 !important;
}

.lang-dialog-card {
  background: rgba(25,25,25,0.95) !important;
  border-radius: 16px !important;
}
.lang-dialog-title {
  color: #fff; font-size: 20px; font-weight: 700;
  padding: 20px !important;
}
.lang-list { background: transparent !important; }
.lang-item { border-bottom: 1px solid rgba(255,255,255,0.06); }
.lang-item:hover { background: rgba(192,57,43,0.15) !important; }
.lang-item-title { color: rgba(255,255,255,0.8) !important; font-weight: 600; font-size: 15px; }
.lang-close-btn {
  background: #c0392b !important; color: #fff !important;
  border-radius: 8px !important; padding: 8px 32px !important;
  font-weight: 600 !important;
}

.map-wrap {
  width: 100%; height: 350px;
  border-radius: 12px; overflow: hidden;
  margin-top: 16px;
}

/* ══════════════════════════════════════════════════════ */
/* FOOTER                                               */
/* ══════════════════════════════════════════════════════ */
.page-footer {
  position: relative; z-index: 1;
  text-align: center; padding: 40px 24px;
  border-top: 1px solid rgba(255,255,255,0.06);
  margin-top: 40px;
}
.footer-logo { display: inline-block; margin-bottom: 12px; }
.footer-logo-img { height: 36px; opacity: 0.7; }
.footer-text { color: rgba(255,255,255,0.3); font-size: 13px; margin: 0; }

/* ══════════════════════════════════════════════════════ */
/* VIDEO.JS OVERRIDES                                   */
/* ══════════════════════════════════════════════════════ */
.vjs-theme-dt { --color-primary: #c0392b !important; }
.vjs-control-bar {
  background: linear-gradient(transparent, rgba(0,0,0,0.7)) !important;
  border-radius: 0 0 12px 12px;
}

/* ══════════════════════════════════════════════════════ */
/* RESPONSIVE                                           */
/* ══════════════════════════════════════════════════════ */

/* Large Desktop */
@media (min-width: 1400px) {
  .main-content { max-width: 1320px; }
}

/* Tablet Landscape & Small Desktop */
@media (max-width: 960px) {
  .live-grid { grid-template-columns: 1fr; }
  .live-channels { order: -1; }
  .channels-list { flex-direction: row; flex-wrap: wrap; max-height: none; }
  .ch-card { flex: 1 1 calc(50% - 8px); min-width: 0; }
  .player-frame { height: 320px; }
  .ashab-grid { grid-template-columns: 1fr; text-align: center; }
  .ashab-cards-area { min-height: 300px; }
  .ashab-cards-wrap { width: 280px; height: 300px; }
  .ashab-card { width: 240px; height: 280px; }
  .ashab-card-main { width: 260px; height: 300px; }
  .ashab-name { font-size: 26px; }
  .sec-title { font-size: 24px; }
  .header-nav { display: none !important; }
  .top-header { padding: 10px 20px; }
}

/* Tablet Portrait */
@media (max-width: 768px) {
  .sec { padding: 48px 0; }
  .sec-head { margin-bottom: 28px; }
  .sec-title { font-size: 22px; }
  .sec-ornament { gap: 8px; margin-bottom: 8px; }
  .orn-line { width: 40px; }
  .orn-icon { height: 20px; }
  .zyara-form .zyara-row { gap: 10px; }
  .zyara-field { min-width: 160px; }
  .player-frame { height: 280px; }
  .channels-list { gap: 6px; }
  .ch-card { padding: 10px 12px; }
  .events-text { font-size: 16px; }
  .ashab-name { font-size: 24px; }
  .ashab-desc { font-size: 15px; }
  .kh-card { padding: 6px; }
  .ashura-btn { padding: 16px 30px; font-size: 15px; }
  .places-grid { grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); }
  .visitor-card { padding: 24px; }
  .visitor-search { margin-bottom: 16px; }
  .visitor-input .v-input__slot { padding: 0 8px !important; }
  .visitor-search-btn { padding: 6px 12px !important; font-size: 12px !important; }
  .visitor-tabs { flex-wrap: wrap; overflow-x: visible; gap: 6px; }
  .vtab { padding: 7px 12px; font-size: 11px; flex-shrink: 0; }
  .visitor-body-title { font-size: 16px; margin-bottom: 12px; }
  .places-grid { grid-template-columns: 1fr; gap: 8px; }
  .place-card { padding: 12px; border-radius: 10px; }
  .place-icon img { height: 32px !important; }
  .place-name { font-size: 13px; }
  .place-addr { font-size: 11px; }
  .footer-logo-img { height: 28px; }
  .footer-text { font-size: 12px; }
}

/* Mobile */
@media (max-width: 600px) {
  .top-header { padding: 10px 14px; }
  .header-logo-img { height: 32px; max-width: 130px; }
  .h-action-btn { width: 36px; height: 36px; border-radius: 8px; }
  .h-action-btn img, .h-action-btn svg { height: 18px; }
  .main-content { padding: 70px 14px 0 14px; }
  .sec { padding: 36px 0; }
  .sec-head { margin-bottom: 20px; }
  .sec-title { font-size: 20px; }
  .sec-ornament { margin-bottom: 6px; }
  .zyara-content { padding: 16px; border-radius: 12px; }
  .zyara-sub { font-size: 17px; margin-bottom: 16px; }
  .zyara-form .zyara-row { flex-direction: column; }
  .zyara-field { min-width: 100%; }
  .zyara-btn { width: 100% !important; justify-content: center; }
  .player-frame { height: 210px; border-radius: 8px; }
  .ch-card { flex: 1 1 100%; padding: 10px 14px; }
  .ch-name { font-size: 12px; }
  .events-card { padding: 16px; }
  .events-text { font-size: 14px; line-height: 1.6; }
  .ashab-grid { gap: 20px; }
  .ashab-cards-wrap { width: 200px; height: 240px; }
  .ashab-card { width: 170px; height: 220px; }
  .ashab-card-main { width: 190px; height: 240px; }
  .ashab-name { font-size: 20px; }
  .ashura-btn { font-size: 12px; padding: 10px 14px; max-width: 100%; }
  .visitor-card { padding: 16px; border-radius: 12px; }
  .visitor-search { margin-bottom: 16px; }
  .visitor-input .v-input__slot { padding: 0 8px !important; }
  .visitor-search-btn { padding: 6px 12px !important; font-size: 12px !important; }
  .visitor-tabs { flex-wrap: wrap; overflow-x: visible; gap: 6px; }
  .vtab { padding: 7px 12px; font-size: 11px; flex-shrink: 0; }
  .visitor-body-title { font-size: 16px; margin-bottom: 12px; }
  .places-grid { grid-template-columns: 1fr; gap: 8px; }
  .place-card { padding: 12px; border-radius: 10px; }
  .place-icon img { height: 32px !important; }
  .place-name { font-size: 13px; }
  .place-addr { font-size: 11px; }
  .footer-logo-img { height: 28px; }
  .footer-text { font-size: 12px; }
}

/* Very Small Mobile */
@media (max-width: 380px) {
  .top-header { padding: 8px 10px; }
  .header-logo-img { height: 28px; max-width: 110px; }
  .h-action-btn { width: 32px; height: 32px; }
  .h-action-btn img, .h-action-btn svg { height: 16px; }
  .main-content { padding: 70px 10px 0 10px; }
  .sec { padding: 28px 0; }
  .sec-title { font-size: 18px; }
  .zyara-content { padding: 12px; }
  .zyara-sub { font-size: 15px; }
  .player-frame { height: 180px; }
  .ashab-cards-wrap { width: 170px; height: 210px; }
  .ashab-card { width: 150px; height: 190px; }
  .ashab-card-main { width: 165px; height: 210px; }
  .ashab-name { font-size: 18px; }
  .ashura-btn { font-size: 12px; padding: 10px 14px; }
}

/* Dialogs Responsive */
@media (max-width: 600px) {
  .dlg-card { border-radius: 12px !important; }
  .dlg-body { padding: 16px !important; }
  .dlg-title { font-size: 16px !important; }
  .dlg-sub { font-size: 13px; }
  .dlg-label { font-size: 12px; }
  .dlg-zyara-text { font-size: 13px; line-height: 1.8; padding: 12px; }
  .dlg-profile { flex-direction: column; text-align: center; }
  .dlg-avatar { width: 56px; height: 56px; }
  .dlg-profile-name { font-size: 16px; }
  .dlg-close { top: 6px; left: 6px; }
  .dlg-close svg { width: 16px; height: 16px; }
  .lang-dialog-card { border-radius: 12px !important; }
  .lang-dialog-title { font-size: 16px !important; padding: 14px !important; }
  .lang-item-title { font-size: 14px; }
  .map-wrap { height: 220px; border-radius: 8px; }
}

/* Landscape Mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .bg-video-wrap video { height: auto; min-height: 100%; }
  .player-frame { height: 200px; }
  .sec { padding: 24px 0; }
}

/* RTL Support */
[dir="rtl"] .place-arrow { transform: scaleX(-1); }
[dir="rtl"] .place-card:hover .place-arrow { transform: scaleX(-1) translateX(-4px); }

/* Touch Device Optimizations */
@media (hover: none) {
  .nav-link:hover, .ch-card:hover, .place-card:hover,
  .kh-inner:hover, .arr-btn:hover { transform: none; }
  .kh-inner:active { transform: scale(0.98); }
  .place-card:active { background: rgba(192,57,43,0.15); }
}
</style>
